import React, { useContext, useEffect, useState } from "react";
import { SingleClassContext } from "../../context/SingleClassContext";
import { CoachesContext } from "../../context/CoachesContext";
import { LocationsContext } from "../../context/LocationsContext";
import { PackagesContext } from "../../context/PackageContext";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import DateTimePicker from "../common/DateTimePicker";
import SelectInstructors from "../global/SelectInstructors";
import { getValue } from "../../utils";
import useBranch from "../../hooks/useBranch";

const SingleClassForm = ({ handleCancel, handleCallback, single_class_id }) => {
  const [first, setFirst] = useState(false);

  const {
    clase,
    spinner,
    postClase,
    createClase,
    addInstructor,
    getSingleClass,
    removeInstructor,
    setPropiedadClase,
  } = useContext(SingleClassContext);
  const { coaches, getCoaches } = useContext(CoachesContext);
  const { locations, getLocations } = useContext(LocationsContext);
  const { paquetes, getAllPaquetes } = useContext(PackagesContext);
  const { class_types, getClassTypes } = useContext(ClassTypeContext);

  const { branch_id } = useBranch();

  useEffect(() => {
    getAllPaquetes();
    getCurrenClase();
    getClassTypes();
    getLocations();
    getCoaches();
    return () => {
      setFirst(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!first && clase !== null) {
      if (Array.isArray(clase.class_instructors)) {
        if (clase.class_instructors.length > 0) {
          setPropiedadClase(
            "instructor_id",
            clase.class_instructors[0].instructor_id
          );
        }
      }
      setFirst(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clase]);

  useEffect(() => {
    getCurrenClase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [single_class_id]);

  const getCurrenClase = () => {
    if (!isNaN(single_class_id)) {
      if (clase !== null) {
        if (String(clase.single_class_id) === String(single_class_id)) {
          return;
        }
      }
      getSingleClass(single_class_id);
    }
    if (clase === null || clase === undefined) {
      createClase();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postClase(clase, handleCallback);
  };

  const renderLocations = () => {
    if (Array.isArray(locations)) {
      if (locations.length > 0 && clase.location_id === "") {
        setTimeout(() => {
          setPropiedadClase("location_id", locations[0].location_id);
          setPropiedadClase("branch_id", locations[0].branch_id);
        }, 100);
      }
      return locations.map((location) => (
        <option key={location.location_id} value={location.location_id}>
          {location.name}
        </option>
      ));
    }
  };

  const renderClassTypes = () => {
    if (Array.isArray(class_types)) {
      const branch_class_types = class_types.filter(
        (class_type) => class_type.branch_id === branch_id
      );
      if (branch_class_types.length > 0 && !clase.class_type_id) {
        setTimeout(() => {
          setPropiedadClase("class_type_id", branch_class_types[0].class_type_id);
        }, 100);
      }
      return branch_class_types.map((class_type) => (
        <option key={class_type.class_type_id} value={class_type.class_type_id}>
          {class_type.name}
        </option>
      ));
    }
  };

  const renderPaquetes = () => {
    if (Array.isArray(paquetes)) {
      return [{ title: "No es evento especial", class_package_id: null }]
        .concat(paquetes)
        .map((paquete) => (
          <option
            key={paquete.class_package_id}
            value={paquete.class_package_id}
          >
            {paquete.title}
          </option>
        ));
    }
  };

  const renderForm = () => {
    if (clase && clase !== null) {
      const class_type_id = getValue(clase, "class_type_id");
      return (
        <form onSubmit={handleSubmit}>
          <label>Tipo de Clase</label>
          <div className="row">
            <div className="col col-md-6">
              <select
                className="form-control mb-3"
                value={class_type_id}
                onChange={(e) =>
                  setPropiedadClase("class_type_id", e.target.value)
                }
              >
                {renderClassTypes()}
              </select>
            </div>
            <div className="col col-md-6"></div>
          </div>
          <label>Descripción</label>
          <input
            type="text"
            className="form-control mb-3"
            value={getValue(clase, "description")}
            onChange={(e) => setPropiedadClase("description", e.target.value)}
          />
          <DateTimePicker
            value={getValue(clase, "class_date", "datetime")}
            modifier={(value) => setPropiedadClase("class_date", value)}
          />
          <SelectInstructors
            instructors={coaches}
            addInstructor={addInstructor}
            removeInstructor={removeInstructor}
            selected={clase.class_instructors}
          />
          <label>Ubicación</label>
          <div className="row">
            <div className="col col-md-6">
              <select
                className="form-control mb-3"
                value={getValue(clase, "location_id")}
                onChange={(e) => {
                  setPropiedadClase("location_id", parseInt(e.target.value));
                }}
              >
                {renderLocations()}
              </select>
            </div>
            <div className="col col-md-6"></div>
          </div>
          <label>Capacidad</label>
          <input
            type="number"
            min={0}
            className="form-control mb-3"
            value={getValue(clase, "capacity")}
            onChange={(e) => setPropiedadClase("capacity", e.target.value)}
          />
          <label>Evento Especial</label>
          <select
            className="form-control mb-3"
            value={getValue(clase, "class_package_id")}
            onChange={(e) =>
              setPropiedadClase("class_package_id", e.target.value)
            }
          >
            {renderPaquetes()}
          </select>
          <div className="row">
            <div className="col col-md-6 text-end">
              <button
                type="button"
                onClick={handleCancel}
                className="btn w-100 text-muted"
              >
                Cancelar
              </button>
            </div>
            <div className="col col-md-6">
              <button
                type="submit"
                disabled={spinner}
                className="btn w-100 btn-primary"
              >
                {spinner ? <div className="spinner-border" /> : "Guardar"}
              </button>
            </div>
          </div>
        </form>
      );
    }
  };

  return <div className="container-fluid px-0">{renderForm()}</div>;
};

export default SingleClassForm;
